import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import _noop from 'lodash/noop';
import { defaultMemoize } from 'reselect';

// Constants
import { EMPTY_ARRAY, EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';

// Components
import InputTableHeader from './components/inputTableHeader';
import InputTableFooter from './components/inputTableFooter';
import InputTableContent from './components/inputTableContent';
import LoadingComponent from './components/loadingComponent';
import EmptyPlaceholderComponent from './components/emptyPlaceholderComponent';
import { createColumns } from './helpers/inputTable.general';
import s from './inputTable.module.scss';
var InputTable = /*#__PURE__*/function (_PureComponent) {
  _inherits(InputTable, _PureComponent);
  var _super = _createSuper(InputTable);
  function InputTable() {
    var _this;
    _classCallCheck(this, InputTable);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "createColumns", defaultMemoize(createColumns));
    _defineProperty(_assertThisInitialized(_this), "renderInputTableHeader", function () {
      var _this$props = _this.props,
        columns = _this$props.columns,
        onAction = _this$props.onAction,
        sortDetails = _this$props.sortDetails,
        headerClassName = _this$props.headerClassName,
        data = _this$props.data;
      return /*#__PURE__*/React.createElement(InputTableHeader, {
        columns: columns,
        onAction: onAction,
        sortDetails: sortDetails,
        headerClassName: headerClassName,
        data: data
      });
    });
    _defineProperty(_assertThisInitialized(_this), "renderInputTableFooter", function () {
      var _this$props2 = _this.props,
        columns = _this$props2.columns,
        footerClassName = _this$props2.footerClassName,
        data = _this$props2.data;
      var footerColumns = _this.createColumns(columns);
      return /*#__PURE__*/React.createElement(InputTableFooter, {
        columns: footerColumns,
        footerClassName: footerClassName,
        data: data
      });
    });
    return _this;
  }
  _createClass(InputTable, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        columns = _this$props3.columns,
        data = _this$props3.data,
        getTdProps = _this$props3.getTdProps,
        onAction = _this$props3.onAction,
        errors = _this$props3.errors,
        EmptyPlaceholder = _this$props3.EmptyPlaceholder,
        loading = _this$props3.loading,
        style = _this$props3.style,
        getRowId = _this$props3.getRowId,
        rowStyle = _this$props3.rowStyle,
        showReOrderableRows = _this$props3.showReOrderableRows,
        className = _this$props3.className,
        showFooter = _this$props3.showFooter,
        showHeader = _this$props3.showHeader,
        highlightRowOnFocus = _this$props3.highlightRowOnFocus,
        contentClassName = _this$props3.contentClassName,
        contentStyle = _this$props3.contentStyle,
        shouldCancelStart = _this$props3.shouldCancelStart,
        rowClassName = _this$props3.rowClassName;
      var containerClassName = "relative ".concat(s.tableContainer, " ").concat(className);
      var dataColumns = this.createColumns(columns);
      return /*#__PURE__*/React.createElement("div", {
        className: containerClassName,
        style: style
      }, showHeader && this.renderInputTableHeader(), /*#__PURE__*/React.createElement(InputTableContent, {
        getRowId: getRowId,
        columns: dataColumns,
        data: data,
        getTdProps: getTdProps,
        onAction: onAction,
        errors: errors,
        loading: loading,
        LoadingComponent: LoadingComponent,
        EmptyPlaceholder: EmptyPlaceholder,
        rowStyle: rowStyle,
        contentClassName: contentClassName,
        showReOrderableRows: showReOrderableRows,
        highlightRowOnFocus: highlightRowOnFocus,
        contentStyle: contentStyle,
        shouldCancelStart: shouldCancelStart,
        rowClassName: rowClassName
      }), showFooter && this.renderInputTableFooter());
    }
  }]);
  return InputTable;
}(PureComponent);
InputTable.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    header: PropTypes.string,
    cellConfigs: PropTypes.arrayOf(PropTypes.shape({
      component: PropTypes.element,
      shouldRender: PropTypes.func,
      mapCellPropsToComponentProps: PropTypes.func
    })),
    headerClassName: PropTypes.string,
    cellClassName: PropTypes.string,
    width: PropTypes.number
  })),
  data: PropTypes.array,
  getTdProps: PropTypes.func,
  onAction: PropTypes.func,
  errors: PropTypes.array,
  loading: PropTypes.bool,
  EmptyPlaceholder: PropTypes.func,
  getRowId: PropTypes.func,
  style: PropTypes.object,
  headerClassName: PropTypes.string,
  className: PropTypes.string,
  showFooter: PropTypes.bool,
  footerClassName: PropTypes.string,
  highlightRowOnFocus: PropTypes.bool,
  showHeader: PropTypes.bool,
  contentClassName: PropTypes.string,
  contentStyle: PropTypes.object,
  shouldCancelStart: PropTypes.func,
  rowClassName: PropTypes.string
};
InputTable.defaultProps = {
  columns: EMPTY_ARRAY,
  data: EMPTY_ARRAY,
  errors: EMPTY_ARRAY,
  getTdProps: _noop,
  onAction: _noop,
  getRowId: _noop,
  loading: false,
  EmptyPlaceholder: EmptyPlaceholderComponent,
  style: EMPTY_OBJECT,
  headerClassName: '',
  className: '',
  showFooter: false,
  footerClassName: '',
  highlightRowOnFocus: false,
  showHeader: true,
  contentClassName: '',
  contentStyle: EMPTY_OBJECT,
  shouldCancelStart: undefined,
  rowClassName: undefined
};
export default InputTable;